import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import {PNoMargin} from '@/typography';
import styles from './tabs.module.scss';

const propTypes = {
  activeTab: PropTypes.string.isRequired,
  setActiveTab: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  tabItems: PropTypes.object.isRequired,
  router: PropTypes.shape({
    push: PropTypes.func.isRequired,
    pathname: PropTypes.string.isRequired
  }).isRequired
};

const Tabs = ({activeTab, setActiveTab, title, tabItems, router}) => {
  const handleTabClick = ({child, routerPushUrl, value}) => {
    if (!child) {
      router.push(routerPushUrl);
    } else {
      const params = new URLSearchParams();
      params.set('tab', value);
      const newUrl = `${router.pathname}?${params.toString()}`;
      router.push(newUrl);
      setActiveTab(value);
    }
  };
  return (
    <div className={cx(styles.sidetab, 'no-print')}>
      <ul>
        <PNoMargin>{title}</PNoMargin>
        {tabItems.map(({text, value, child, routerPushUrl}, index) => (
          <li key={index} className={activeTab === value ? styles.active : ''}>
            <div onClick={() => handleTabClick({child, routerPushUrl, value})}>{text}</div>
          </li>
        ))}
      </ul>
    </div>
  );
};

Tabs.propTypes = propTypes;

export default Tabs;
